import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorrowerSmartComponent } from './borrower-smart/borrower-smart.component';
import { BorrowerHeaderModule } from 'app/borrower-header/borrower-header.module';
import { BorrowerSidebarModule } from 'app/borrower-sidebar/borrower-sidebar.module';
import { BorrowerDetailsModule } from 'app/modules/borrower/components/borrower-details/borrower-details.module';
import { Title } from '@angular/platform-browser';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { DoNotContactModule } from 'app/do-not-contact/do-not-contact.module';

@NgModule({
  declarations: [
    BorrowerSmartComponent
  ],
  imports: [
    CommonModule,
    BorrowerHeaderModule,
    BorrowerSidebarModule,
    BorrowerDetailsModule,
    MatDialogModule,
    DoNotContactModule,
    MatProgressSpinnerModule,
    MatCardModule
  ],
  exports: [
    BorrowerSmartComponent
  ],
  providers: [
    Title
  ]
})
export class BorrowerPageModule { }
